module.exports = __webpack_public_path__ + "static/cf-bold-ff5b984914f4b1f61a9703ca6424bc91.eot";